import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Flag } from "lucide-react";
import { api } from "@/lib/api";
import { formatDeShort } from "@/lib/date";
import { HummingbirdCelebration } from "@/components/Hummingbird";

const fmt = (n) => Number(n).toLocaleString("de-DE", { maximumFractionDigits: 1 });

function dueLabel(h) {
  if (h.overdue) return { text: `${Math.abs(h.days_left)} ${Math.abs(h.days_left) === 1 ? "Tag" : "Tage"} überfällig`, cls: "text-red-700 bg-red-50 border-red-200" };
  if (h.days_left <= 7) return { text: h.days_left === 0 ? "Frist heute" : `Frist in ${h.days_left} ${h.days_left === 1 ? "Tag" : "Tagen"}`, cls: "text-amber-800 bg-amber-50 border-amber-200 font-medium" };
  return { text: `noch ${h.days_left} Tage`, cls: "text-slate-600 bg-slate-50 border-slate-200" };
}

export default function HandoverWidget() {
  const [data, setData] = useState(null);
  const [queue, setQueue] = useState([]);
  useEffect(() => {
    api.get("/me/handovers").then((r) => { setData(r.data); setQueue(r.data.celebrate || []); }).catch(() => setData({ upcoming: [] }));
  }, []);
  const close = () => {
    const [cur, ...rest] = queue;
    if (cur) api.post(`/me/handovers/${cur.client_id}/celebrated`).catch(() => {});
    setQueue(rest);
  };
  if (!data) return null;
  return (
    <>
      <HummingbirdCelebration item={queue[0]} onClose={close} />
      {data.upcoming.length > 0 && (
        <div className="mt-8 border border-slate-200 bg-white p-6" data-testid="handover-widget">
          <div className="flex items-center gap-2 mb-4">
            <Flag size={15} className="text-[#0a788c]" />
            <span className="text-xs font-bold uppercase tracking-overline text-slate-500">Deine nächsten Übergaben</span>
          </div>
          <div className="divide-y divide-slate-100">
            {data.upcoming.map((h) => {
              const d = dueLabel(h);
              return (
                <div key={h.client_id} className="py-2.5 flex flex-wrap items-center gap-3 text-sm" data-testid={`handover-item-${h.client_id}`}>
                  <Link to={`/avgs/${h.client_id}`} className="flex-1 min-w-[160px] text-slate-900 hover:underline underline-offset-4">{h.client_name}</Link>
                  <span className="text-xs text-slate-500">{fmt(h.remaining_ue)} UE offen · an {h.next_name}</span>
                  <span className="font-mono text-xs text-slate-800">bis {formatDeShort(h.deadline)}</span>
                  <span className={`text-[11px] px-2 py-0.5 border ${d.cls}`} data-testid={`handover-due-${h.client_id}`}>{d.text}</span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
}
